var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Rootservers")]),_c('p',[_vm._v("Rootserver")])])}
var staticRenderFns = []

export { render, staticRenderFns }